module.exports = __webpack_public_path__ + "img/H3F2_new.e82ff137.jpg";